/* eslint-disable */
import {getUserInfo, getSessionObj, getUrlParams} from "./utils";    
let ua = window.navigator.userAgent.toLowerCase();
function isIOS(){
  return /(iPhone|iPad|iPod|iOS)/i.test(ua);
};
function isAndroid() {
  return /android/i.test(ua);
};
function isWeixin() {
  return ua.match(/MicroMessenger/i) === "micromessenger";
};
function isDaka() {
	return window.navigator.userAgent.indexOf("daka") > -1;		
};
function isZJCW() {
	return window.navigator.userAgent.indexOf("zjcw-app") > -1
};
//神策注册登录后调
export function myIdentify(obj) {
  	
	var sensorsUid= "88888888888";
	if(getSessionObj("dakaUser")&&getSessionObj("dakaUser").userId){
		sensorsUid = getSessionObj("dakaUser").userId
	}
	if(obj&&obj.userId){
		sensorsUid = obj.userId
	}
	
	//注入用户登录后userid		
	window.sensors.login(sensorsUid);
	let type='H5';
	if(isWeixin()){
		type="1";
	}else if(isIOS()){
		type="iOS";
	}else if(isZJCW()){
		type="AD";
	}
	let appEvn = 'h5'
	if(isDaka()){
		appEvn="daka";
	}else if(isAndroid()){
		appEvn="zjcw";
	}

	// 注册公共属性
	window.sensors.registerPage({
		platform_type: type,//系统环境是ios还是安卓还是h5
		app_evn:appEvn,//app环境是在大卡里还是在车旺app里
		is_login:sensorsUid?true:false,//是否已登录		
        bxsc_app_name: "优驾宝",//应用名称		
	});
	//设置用户属性
	if(obj){
		window.sensors.setProfile({
			user_id:obj.userId?obj.userId:'',//用户id
			user_mobile : obj.mobile?obj.mobile:"",//手机号				
			nick_name: obj.nickName? obj.nickName:"",//昵称
			user_avatar:obj.avatar?obj.avatar:"", //头像
			user_sex :obj.sex?obj.sex:"",//1 男 2 女
		});	
	}
}
export function myTrack(eventName, attribute, cb) {
	window.sensors.track(eventName, attribute);//目前神策手动track这个api不支持回调,神策埋点原理和诸葛类似通过调用一张很小的gif图片把参数放到图片地址后面，这样一般传递很快
	if(cb){
		setTimeout(() => {
			cb();
		}, 300);
	}
}

//官网地址 https://manual.sensorsdata.cn/sa/latest/zh_cn/tech_sdk_client_web_use-7545024.html